<template>
  <div class="login-container">
    <!-- 系统名称 -->
    <div class="system-name">
      GPT软件许可申请系统
    </div>
    <!-- 登录表单 -->
    <el-form class="login-form" ref="loginForm" :model="loginForm" label-width="100px"  @keyup.enter.native="login">
      <el-form-item label="用户名">
        <el-input v-model="loginForm.username" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="密码">
        <el-input v-model="loginForm.password" show-password autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="login">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import {ElMessageBox} from "element-plus";

export default {
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
      },
    };
  },
  async created() {
    let jwtSession = localStorage.getItem("licUserJwt")
    let userCodeSession = localStorage.getItem("licUserCode")
    if(jwtSession == null || jwtSession.length == 0) { return;}
    if(userCodeSession == null || userCodeSession.length == 0) { return;}
    await axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/checkJwt", {
      userCode: userCodeSession,
      userJwt: jwtSession
    }).then(res => {
      console.log(res.data)
      if (res.data.success == true) {
        this.$router.push({path:'/home/6-1'});
      }
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    async login() {
      // 在这里处理登录逻辑
      await axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/checkLogin", {
        userCode: this.loginForm.username,
        userPwd: this.loginForm.password
      }).then(res => {
        console.log(res.data)
        if (res.data.JWT.length > 0) {
          localStorage.setItem("licUserCode", this.loginForm.username);
          localStorage.setItem("licUserJwt", res.data.JWT );
          localStorage.setItem("licUserINFO", JSON.stringify(res.data.USERINFO));
          this.$router.push({path:'/home/6-1'});
        }
      }).catch(err => {
        console.log(err)
        ElMessageBox.confirm("登录失败，密码不正确或用户名错误，如还不能登录，请联系管理员!")
      })
    }
  },
};
</script>

<style>
.system-name {
  text-align: center;
  margin-bottom: 20px;
  font-size: 24px;
  color: #333;
}

.login-container {
  max-width: 400px;
  margin: 100px auto;
  padding: 25px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  box-shadow: 2px 12px rgba(, , , .1);
}

.login-form {
  margin: 20px;
}
</style>

<!--<script>-->
<!--import axios from "axios";-->

<!--export default {-->
<!--  async created() {-->
<!--//     let urlQuery = this.$route.query;-->
<!--//     console.log(urlQuery)-->
<!--//     if (Object.prototype.hasOwnProperty.call(urlQuery,"jwt")) {-->
<!--//       localStorage.setItem("lyqtJwt", urlQuery.jwt);-->
<!--//       console.log("getJwt", urlQuery.jwt);-->
<!--//     }-->
<!--//     if (process.env.NODE_ENV === "development")-->
<!--//     {-->
<!--//       localStorage.setItem("lyqtJwt", "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiVDA2MTU4NjEiLCJ1c2VyX2lkIjoiZXNsaHhvYWZscmM5NXo2dGgxZDE4MTFpIiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA0NTQ3IiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnZzku7IiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY3OTM2MjEwNSwiZXhwIjoxNjgxOTU0MTA1fQ.eEdNKXSd51agb3rVba308JJXRUq8UEeQpwPvVb0MaAoiGhMBXBTe9MQE243Yc2N4ALfPYPuVvyn9tya_ctXRoIltfhzpw7vrk6Udf2vOMDA7ZZG8fcETKhaC1H2E4bURzjZIYlNZkGD0Yz10qbjIeR94w2HcSUf0njFQdzLfyyzC4vHy3y1-hZap5_BP634jms6Cu8HfispKe55R2ZZKZ7y74nf4Xz5LstjPWaUFnkUyGfZj_Q-JxcTH88Q0OyXVd75bfpBAYceggZTtezNFKd7Mik2zYfGMl4ibQGwKSuQ4ybbyn3Wr2T9k6uwfkMG1j1mAjQDESSAqbFLp01sKXw");-->
<!--//       this.$router.push({path:'/home/6-1'});-->
<!--//       return-->
<!--//     }-->
<!--// //todo 存在一个问题，当令牌失效，重登时，用户信息未更新-->
<!--//     let jwtSession = localStorage.getItem("lyqtJwt");-->
<!--//     if (jwtSession == null) jwtSession = {};-->
<!--//     if (jwtSession.length > 0) {-->
<!--//       await axios.post("/checkToken", {-->
<!--//         appId: "7cff6a1e-1270-4ab0-a8c6-f902b9491fb7",-->
<!--//         appSecret: "vdk7dhraws5x676pkxywifms",-->
<!--//         token: jwtSession-->
<!--//       }).then(res => {-->
<!--//         console.log(res.data)-->
<!--//         if (res.data.code == "success") {-->
<!--//           localStorage.setItem("lyqtUserInfo", JSON.stringify(res.data.data));-->
<!--//           this.$router.push({path:'/home/6-1'});-->
<!--//         }-->
<!--//       }).catch(err => {-->
<!--//         console.log(err)-->
<!--//       })-->
<!--//     }-->
<!--//     else {-->
<!--//       localStorage.removeItem("checkedBlock");-->
<!--//       localStorage.removeItem("lyqtUserInfo");-->
<!--//       localStorage.removeItem("lyqtJwt");-->
<!--//       //用户中心登出-->
<!--//       localStorage.removeItem("user_token");-->
<!--//       localStorage.removeItem("current_user");-->
<!--//       window.location.href = "http://usercenter.tlm.pcep.cloud/front/usercenter/user/logout?redirectUrl=http://usercenter.tlm.pcep.cloud/front/usercenter/user/login?appId=7cff6a1e-1270-4ab0-a8c6-f902b9491fb7";-->
<!--//     }-->
<!--  }-->
<!--}-->
<!--</script>-->